// CCshopAdminRequest.tsx (Main Page)
import { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import CCshopAdminRequestIntro from "@/components/contact/ccshop-admin/CCshopAdminRequestIntro";
import CCshopAdminRequestForm from "@/components/contact/ccshop-admin/CCshopAdminRequestForm";
import Faq from "@/components/contact/faq/Faq";
import PageMeta from "@/components/common/PageMeta";
import data from "@/data/contact/faq.json";
import Spacing from "@/components/common/Spacing";

const CCshopAdminRequest = () => {
  useEffect(() => {
  window.scrollTo(0, 0);
  }, []);

  const formRef = useRef<HTMLDivElement>(null);
  
  const scrollToForm = () => {
  if (formRef.current) {
    formRef.current.scrollIntoView({ behavior: "smooth" });
  }
  };

  return (
  <Container>
    <PageMeta title="Acces Admin CC Shop" description="Solicită acces administrator pentru demo CC Shop" />
    <Spacing size={5} />
    <CCshopAdminRequestIntro onClick={scrollToForm} />
    <Spacing size={4} />
    <div ref={formRef}>
    <CCshopAdminRequestForm />
    </div>
    <Spacing size={2} />
    <Faq data={data} />
  </Container>
  );
};

export default CCshopAdminRequest;